export default __webpack_public_path__ + "static/media/Google.1b60c348.svg";